<template>
<div class="split-section">
  <div v-if="!companies" class="item">
    <slot name="left" class="column">
    </slot>
  </div>
  <div v-if="!companies" class="item">
    <slot name="right" class="column">
    </slot>
  </div>
  <slot v-if="companies" name="default"></slot>
</div>
</template>

<script>
export default {
  props: {
    companies: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.split-section {
  width: 100%;
  display: flex;

  .item {
    width: 50%;
    padding: 1rem;
  }
  .item:not(:last-child) {
    border-right: 1px solid #dddddd;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/general/split-section.vue